const types = {
  carNumber: "車番",
  inspector: "担当者",
  berth: "荷受け口",
  assessmentList: "結果一覧",
  impurityRegister: "登録",
  impurityList: "結果一覧",
  impuritySaveList: "下書き",
  impurity: "不適合品",
  composition: "成分分析",
  logout: "ログアウト",
  recycler: "納入業者",
  trader: "商社",
  scrapCategory: "品種",
  assessmentDate: "検収日",
  assessmentStartTime: "開始",
  assessmentStopTime: "終了",
  scrapCategorySelectedAt: "品種選択",
  camera: "カメラ",
  remoteAssessment: "遠隔検収",
  period: "期間",
};

type Types = keyof typeof types;

export type { Types };
export { types };
